import React, { memo, useCallback, useRef } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import './nodeStyles.css';

export interface AddRoundNodeData {
  isDisabled: boolean;
  onClick: () => void;
}

const AddRoundNode: React.FC<NodeProps> = ({ data }) => {
  const { isDisabled, onClick } = data as unknown as AddRoundNodeData;
  const isClickingRef = useRef(false);
  
  const handleClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    
    if (isDisabled || isClickingRef.current) return;
    
    // Prevent double-clicks
    isClickingRef.current = true;
    onClick();
    
    // Reset after a short delay
    setTimeout(() => {
      isClickingRef.current = false;
    }, 300);
  }, [isDisabled, onClick]);
  
  return (
    <div className={`rf-node rf-node--add-round ${isDisabled ? 'rf-node--disabled' : ''}`}>
      {/* Target handle on left side - centered */}
      <Handle
        type="target"
        position={Position.Left}
        className="rf-handle rf-handle--target rf-handle--pill-center"
      />
      
      <button
        type="button"
        className={`rf-node__add-btn ${isDisabled ? 'rf-node__add-btn--disabled' : ''}`}
        onClick={handleClick}
        disabled={isDisabled}
        title={isDisabled ? 'Maximum rounds reached' : 'Add round'}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>
    </div>
  );
};

export default memo(AddRoundNode);
